var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImagefile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1600_22678)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.342 24.342L87.658 3.658C86.258 2.258 84 2 84 2H26C21.6 2 18 5.6 18 10V118C18 122.4 21.6 126 26 126H102C106.4 126 110 122.4 110 118V28C110 28 109.742 25.742 108.342 24.342Z",
    fill: "#E7EBF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.342 24.342L87.658 3.658C86.258 2.258 84 2 84 2V20C84 24.4 87.6 28 92 28H110C110 28 109.742 25.742 108.342 24.342Z",
    fill: "#00B495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90 82C90 84.2 88.2 86 86 86H42C39.8 86 38 84.2 38 82V46C38 43.8 39.8 42 42 42H86C88.2 42 90 43.8 90 46V82Z",
    fill: "#00A7E4",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 56C50.2091 56 52 54.2091 52 52C52 49.7909 50.2091 48 48 48C45.7909 48 44 49.7909 44 52C44 54.2091 45.7909 56 48 56Z",
    fill: "#D1E7F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 56L38 82C38 84.2 39.8 86 42 86H54L74 66L64 56Z",
    fill: "#00B495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54 86H86C88.2 86 90 84.2 90 82V70L80 60L54 86Z",
    fill: "#00B495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.988 27.772C111.952 27.47 111.596 24.768 109.758 22.928L89.072 2.244C87.234 0.404 84.53 0.048 84.228 0.014C84.152 0.004 84.076 0 84 0H26C20.486 0 16 4.486 16 10V118C16 123.514 20.486 128 26 128H102C107.514 128 112 123.514 112 118V28C112 27.924 111.996 27.848 111.988 27.772ZM106.928 25.756C106.998 25.826 107.048 25.92 107.11 26H92C88.692 26 86 23.308 86 20V4.89C86.08 4.952 86.172 5.002 86.244 5.072L106.928 25.756ZM102 124H26C22.692 124 20 121.308 20 118V10C20 6.692 22.692 4 26 4H82V20C82 25.514 86.486 30 92 30H108V118C108 121.308 105.308 124 102 124Z",
    fill: "#334D87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86 40H42C38.692 40 36 42.692 36 46V82C36 85.308 38.692 88 42 88H86C89.308 88 92 85.308 92 82V46C92 42.692 89.308 40 86 40ZM42 44H86C87.102 44 88 44.898 88 46V65.172L81.414 58.586C80.632 57.804 79.368 57.804 78.586 58.586L74 63.172L65.414 54.586C64.632 53.804 63.368 53.804 62.586 54.586L40 77.172V46C40 44.898 40.898 44 42 44ZM40.14 82.688L64 58.828L71.172 66L53.172 84H42C41.142 84 40.422 83.45 40.14 82.688ZM86 84H58.828L80 62.828L88 70.828V82C88 83.102 87.102 84 86 84Z",
    fill: "#334D87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 58C51.308 58 54 55.308 54 52C54 48.692 51.308 46 48 46C44.692 46 42 48.692 42 52C42 55.308 44.692 58 48 58ZM48 50C49.102 50 50 50.898 50 52C50 53.102 49.102 54 48 54C46.898 54 46 53.102 46 52C46 50.898 46.898 50 48 50Z",
    fill: "#334D87"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1600_22678"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagefile);
export default __webpack_public_path__ + "static/media/Imagefile.dc22579da84313ff0f62561d08ba2763.svg";
export { ForwardRef as ReactComponent };